module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//19.jpg?4ac1f1c46258b8072aca94ba9468b7f0";